module.exports = __webpack_public_path__ + "static/media/11.a0f84b69.png";